import { Button, TableContainer, Box, Flex, ButtonGroup } from '@chakra-ui/react'
import { AiOutlineArrowLeft, AiOutlineDown, AiOutlineUp } from 'react-icons/ai'
import * as T from '../../../../../../../components/Table'
import { memo, useEffect, useState } from 'react'
import { List } from './List'

export const TableAgendamentos = memo(({ data, onClose }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const hasMoreItems = data?.length > 1
  const [sortedDates, setSortedDates] = useState([])

  useEffect(() => {

    const sortedData = [...(data || [])]?.sort((a, b) => {
      const parseDate = (str) => {
        const [date, time] = str.split(' às ')
        const [day, month, year] = date.split('/').map(Number)
        const [hour, minute] = time.split(':').map(Number)

        return new Date(year, month - 1, day, hour, minute)
      };

      return parseDate(a.data_contato) - parseDate(b.data_contato)
    })

    setSortedDates(sortedData)

  }, [data])

  const displayData = isExpanded ? sortedDates : sortedDates?.slice(0, 1)
  
  return (
    <Box py={1} position="relative">
      {hasMoreItems && (
        <Button
          position="absolute"
          right="2"
          top="-40px"
          zIndex={3}
          size="sm"
          fontSize="14px"
          fontWeight="semibold"
          bgColor="transparent"
          color="#FFA200"
          border="1px solid #FFA200"
          onClick={() => setIsExpanded(!isExpanded)}
          rightIcon={isExpanded ? <AiOutlineUp /> : <AiOutlineDown />}
        >
          {isExpanded ? 'Ver menos' : `Ver mais (${data.length - 1})`}
        </Button>
      )}

      <TableContainer w="100%" maxH="160px" overflowY="auto" mb={4}>
        <T.Table>
          <T.Thead position="sticky" top={0} bg="white" zIndex={2}>
            <T.Tr>
              <T.Th>Data Contato</T.Th>
              <T.Th>Data Agendado</T.Th>
              <T.Th>Observações</T.Th>
              <T.Th>Tipo de Agendamento</T.Th>
              <T.Th>Conteúdo do Retorno</T.Th>
              <T.Th>Ações</T.Th>
            </T.Tr>
          </T.Thead>
          <T.Tbody>
            <List data={displayData} />
          </T.Tbody>
        </T.Table>
      </TableContainer>

      <Flex justify="flex-end">
        <Button
          maxW="181px"
          w="100%"
          fontSize="15px"
          fontWeight="semibold"
          bgColor="transparent"
          color="#FFA200"
          border="1px solid #FFA200"
          onClick={onClose}
        >
          <AiOutlineArrowLeft style={{ marginRight: '5px' }} />
          Voltar
        </Button>
      </Flex>
    </Box>
  )
})

TableAgendamentos.displayName = 'TableAgendamentos'
